import ModalMenuItem from "../../ModalMenu/ModalMenu"
import { getStatusByCode } from "../../utils/statusConfig"
import useStyle from "./useStyle"

function TableItem({ item }) {
  const classes = useStyle()

  const formatDate = (date) => {
    let formattedDate
    if (date) {
      const newDate = new Date(date)
      formattedDate =
        newDate.getDate() +
        "/" +
        (newDate.getMonth() + 1) +
        "/" +
        newDate.getFullYear()
    } else {
      formattedDate = ""
    }
    return formattedDate
  }

  return (
    <tr className={classes.row}>
      <td className={classes.cuit}>{item.cuitDestinatario}</td>
      {/* <td className={classes.name}>razon social</td> */}
      <td
        className={classes.status}
        style={{
          color: item.subscriptionStatus
            ? getStatusByCode(item.subscriptionStatus).color
            : "#6e7a76",
        }}
      >
        {item.subscriptionStatus
          ? getStatusByCode(item.subscriptionStatus).title
          : ""}
      </td>
      <td className={classes.date}>{formatDate(item.lastStatusChangeDate)}</td>
      <td className={classes.itemKebab}>
        <ModalMenuItem item={item} />
      </td>
    </tr>
  )
}

export default TableItem
